// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, LoadCart, PopulateApiParameter, PopulateCart, UpdateSession } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.cart = {
        ...props.cart,
        shipToId: (props.parameter as any).shipToId || props.cart.shipToId,
        properties: {
            ...props.cart.properties,
            willCallWarehouse:
            (props.parameter as any).willCallWarehouse || props.cart.properties["willCallWarehouse"] || "",
        },
    };
};

export const XngPopulateCart: typeof PopulateCart = props => {
    const state = props.getState();
    // xng-change 
    const { editedCartNotes, additionalEmails } = state.pages.checkoutShipping;
    const { cartId } = parseQueryString<{ cartId?: string }>(window.location.search) || state.pages.checkoutShipping;

    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart available while trying to update the current cart.");
    }

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;

    props.cart = {
        ...cart,
        notes,
        additionalEmails: additionalEmails === undefined ? cart.additionalEmails : additionalEmails,
    };
};

export const XUpdateSession: typeof UpdateSession = async props => {
    const { updatedShipTo, updatedBillTo, cart, getState } = props;
    // xng-change 
    const { cartId } = parseQueryString<{ cartId?: string }>(window.location.search) || getState().pages.checkoutShipping;

    if (!cartId && (updatedShipTo || updatedBillTo)) {
        await updateSession({
            session: {
                billToId: updatedBillTo?.id ?? cart.billToId,
                shipToId: updatedShipTo?.id ?? cart.shipToId,
                customerWasUpdated: true,
            } as Session,
        });
    }
};

export const XLoadCart: typeof LoadCart = props => {
    const state = props.getState();
    // xng-change 
    const { cartId } = parseQueryString<{ cartId?: string }>(window.location.search) || state.pages.checkoutShipping;
    if (cartId) {
        props.dispatch(loadCart({ cartId }));
    } else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};

addToChainBefore(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, PopulateCart, XngPopulateCart);
replaceInChain(chain, UpdateSession, XUpdateSession);
replaceInChain(chain, LoadCart, XLoadCart);
